export default __webpack_public_path__ + "static/media/E3.cc85d894.svg";